import { PageContainer, PageHeader } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { materialsSearchSchema } from '@/hooks/queries/useMaterials'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { MaterialsDataTable } from './-components/MaterialsDataTable'

export const Route = createFileRoute('/_auth/_modules/_app/materials/bcp-priced/')({
  component: RouteComponent,
  validateSearch: (search) => materialsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('materials')

  return (
    <PageContainer>
      <PageHeader>{t('bcpPricedPage.header')}</PageHeader>
      <Card>
        <CardContent className="pt-6">
          <MaterialsDataTable />
        </CardContent>
      </Card>
    </PageContainer>
  )
}
